import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Timeline from 'components/base/Timeline';
import {
  ActivityTimelineData,
  fetchActivityTimelineData
} from 'data/activityTimelineData';
import { Col, Row } from 'react-bootstrap';

const ActivityTimeline: React.FC = () => {
  const [data, setData] = useState<ActivityTimelineData[]>([]);

  const fetchData = async () => {
    try {
      const timelineData = await fetchActivityTimelineData();
      setData(timelineData);
    } catch (error) {
      console.error('Error fetching timeline data:', error);
    }
  };

  useEffect(() => {
    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 2000); // Actualizar cada 2,000 ms

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar
  }, []);

  return (
    <Timeline variant="vertical">
      {data.map((item, index) => (
        <Timeline.Item className="position-relative" key={item.id}>
          <Row className="g-md-3">
            <Col xs="auto" md="auto" className="d-flex pe-0">
              <Timeline.OppositeContent>
                <p className="fs-10 fw-semibold text-body-tertiary text-opacity-85 text-end mb-0">
                  {item.oppositeContent.date}
                  <br className="d-none d-md-block" />{' '}
                  {item.oppositeContent.time}
                </p>
              </Timeline.OppositeContent>
              <Timeline.Separator className="position-md-relative me-2">
                <Timeline.Dot className="bg-body-emphasis">
                  <FontAwesomeIcon
                    icon={item.separator.icon}
                    className="text-primary-dark fs-9"
                  />
                </Timeline.Dot>
                {index !== data.length - 1 && (
                  <Timeline.Bar className="h-100 border-dashed" />
                )}
              </Timeline.Separator>
            </Col>
            <Col className="px-0">
              <Timeline.Content className="px-0">
                <h5 className="fs-9 mb-0">{item.content.title}</h5>
                <p className="fs-9 mb-0">
                  by{' '}
                  <span className="fs-9 text-primary-dark">
                    {item.content.username}
                  </span>
                </p>
                <p
                  className={classNames('fs-10 text-body-secondary lh-sm', {
                    'mb-3': index !== data.length - 1,
                    'mb-0': index === data.length - 1
                  })}
                >
                  {item.content.description}
                </p>
              </Timeline.Content>
            </Col>
          </Row>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default ActivityTimeline;
